var React = require('react');

function PaginationLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M560-221.91 301.91-480 560-738.09 634.09-664l-184 184 184 184L560-221.91Z"}));
}

PaginationLeft.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = PaginationLeft;

PaginationLeft.default = PaginationLeft;
